module.exports = __webpack_public_path__ + "static/media/EmptyBudgetNew.14744b0c.png";